import { ChangeDetectionStrategy, Component, Input, EventEmitter, Output } from '@angular/core';

import { User } from '../../../shared/models/user';
import { environment } from '../../../../environments/environment';
import { MobileSideMenuComponent } from '../mobile-side-menu/mobile-side-menu.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-ui-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent {

  isUserDropdownOpen = false;
  languageDropdownOpen = false;
  availableLanguages = environment.languageSettings.availableLanguages;

  @Input() imagePath: string;
  @Input() selectedLanguage = 'en';
  @Input() isLoggedIn: boolean;
  @Input() userProfileUrl: string;
  @Input() user: User;

  @Output() changeLanguage = new EventEmitter<string>();
  @Output() login = new EventEmitter();
  @Output() logout = new EventEmitter();
  @Output() openSettings = new EventEmitter();

  onLogin() {
    this.login.emit();
  }

  onLogout() {
    this.logout.emit();
  }

  onChangeLanguage(language: string) {
    this.changeLanguage.emit(language);
    this.languageDropdownOpen = false;
  }

  onOpenSettings() {
    this.openSettings.emit();
  }

  toggleUserDropdown() {
    this.isUserDropdownOpen = !this.isUserDropdownOpen;
  }

  toggleSettingsMenu(mobileSideMenu: MobileSideMenuComponent) {
    mobileSideMenu.toggleMobileMenu();
  }

  toggleLanguageDropdown() {
    this.languageDropdownOpen = !this.languageDropdownOpen;
  }

  clickOutsideOfUserDropdown() {
    this.isUserDropdownOpen = false;
  }

  clickOutsideOfLanguageDropdown() {
    this.languageDropdownOpen = false;
  }

}
